<template lang="pug">
label.input-text
  span.input-text__label Phone *
  input.input-text__input(
    id="field-login-phone"
    type="tel"
    placeholder=""
    v-model.trim="value"
    @keyup="changeFieldValue()"
    v-maska="['+1 (###) ###-####', '+1 (###) ###-####']"
  )
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldPhone',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldPhone',
        value: this.value
      })
    }
  }
}
</script>
